import { useContext, useEffect } from 'react';

import * as fullStory from 'js/lib/fullstory';

import { SGAPageContext } from 'bundles/grading/components/staff-graded-assignments/SGAPageContext';

export default function GradingFullStory() {
  const {
    submissionData,
    pageData: {
      courseId,
      courseBranchId,
      currentItem,
      currentItemId,
      gradingGroupId,
      currentCourseSlug,
      currentContextId,
    },
  } = useContext(SGAPageContext);

  const { submission } = submissionData.data || {};

  useEffect(() => {
    fullStory.start();

    fullStory.set({
      isQuickGrader: true,
      courseId,
      courseBranchId,
      currentItemId,
      gradingGroupId,
      currentCourseSlug,
      currentContextId,
      currentItemName: currentItem.name,
      currentItemIsGraded: currentItem.isGraded,
      currentQuestionId: submission?.currentQuestionId,
      currentRubricId: submission?.currentRubricId,
    });

    return () => {
      fullStory.stop();
    };
  });

  return null;
}
